export const createAuditMutation = (entityId: number, year: number, auditorId: number) => {
    return `mutation {
        createAudit(entityId: ${entityId}, year: ${year}, auditorId: ${auditorId}){
            audit {
                id
                year
                auditor {
                    id
                    name
                }
            }
        }
    }`
}